import React from 'react';
import { Link } from 'react-router-dom';
import UserProfile from './UserProfile';

const Navigation = () => {
  return (
    <nav className="bg-white shadow-md">
      <div className="container-custom">
        <div className="flex justify-between items-center h-16">
          {/* YK Logo - Left Corner */}
          <Link to="/" className="flex items-center">
            <img 
              src="https://stssevastorage.blob.core.windows.net/ykwebsite/logo.png" 
              alt="Yugal Kunj" 
              className="h-14 w-auto"
            />
          </Link>

          {/* Login Button - Right Corner */}
          <div className="flex items-center">
            <UserProfile />
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navigation;
